import { __awaiter, __generator } from "tslib";
export default [
    {
        id: '@mc-tenant-setting',
        path: '/mc-tenant-setting',
        ref: '/',
        onload: function () { return import('./TenantSettingView'); },
        onbefore: function (app) { return __awaiter(void 0, void 0, void 0, function () {
            var modelList;
            return __generator(this, function (_a) {
                modelList = require('./model').modelList;
                app.collection.register(modelList);
                return [2];
            });
        }); },
    },
    {
        point: '@@layers',
        prefix: '@mc-tenant-setting',
        onload: function () { return require('./layers').default; },
    },
];
